import { NOT_AVAILABLE } from "~/common/constants";
import { usaStateAbbreviations } from "~/common/constants/usaStates";
import { Patient, replaceUnderscores } from "~/common/utils";

export interface ConsultationsRequestsRowProps {
  id: string;
  unreviewed: boolean;
  patientName: string;
  patient: Patient;
  invitationLinkName: string;
  date?: string;
  description?: string;
  state?: string;
}

export const formatConsultationRequestRowData = (
  patient: Patient,
): ConsultationsRequestsRowProps => {
  const {
    id,
    name,
    last_name,
    last_feed,
    organization_patients,
    consultation,
    addresses,
  } = {
    ...patient,
  };
  const address = addresses?.[0];
  const consultationStatus = consultation?.status;
  const usaState = address?.state
    ? (address.state.toLowerCase() as keyof typeof usaStateAbbreviations)
    : undefined;

  const usaStateAbbrev = usaState
    ? usaStateAbbreviations[usaState]
    : NOT_AVAILABLE;

  return {
    id,
    patientName: `${name} ${last_name}`,
    description: consultationStatus && replaceUnderscores(consultationStatus),
    unreviewed: !organization_patients?.[0].is_reviewed,
    date: last_feed?.created_at,
    invitationLinkName: organization_patients?.[0].invitation_link.label,
    patient: patient,
    state: usaStateAbbrev ?? NOT_AVAILABLE,
  };
};
